import { forwardRef } from 'react';

import { Dialog } from '@/components/atoms';
import { DialogTitleProps } from '@/components/atoms/Dialog/DialogTitle';
import { cn } from '@/lib/utils/tailwind';

type SheetTitleProps = DialogTitleProps;

const SheetTitle = forwardRef<HTMLHeadingElement, SheetTitleProps>(
  ({ className, children, ...props }, ref) => (
    <Dialog.Title
      className={cn(
        [
          'text-lg',
          'font-semibold',
          'leading-none',
          'text-(--color-text-primary)',
          'tracking-widest',
        ],
        className,
      )}
      ref={ref}
      {...props}
    >
      {children}
    </Dialog.Title>
  ),
);
SheetTitle.displayName = 'SheetTitle';

export { SheetTitle, type SheetTitleProps };
